import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import APIService from '../../Service/APIService';
import { Row, Col, Input, Upload, message, Button, Modal } from 'antd';
import CustomHeader from '../CustomHeader/CustomHeader';
import "./IVRCss.css";
import Select from 'react-select';
import { InboxOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { useAuth } from '../AuthProvider.js';

const AddIVRManufacturer = () => {
  const { user } = useAuth();
  const userData = user;
  const params = useParams();
  const [ivrData, setIvrData] = React.useState(null);
  // const [manufacturerData, setManufacturerData] = React.useState(null);
  const [manufacturerOptions, setManufacturerOptions] = React.useState([]);
  const [selectedManufacturer, setSelectedManufacturer] = React.useState(null);
  const [caseID, setCaseID] = React.useState("");
  const [insuranceStatus, setInsuranceStatus] = React.useState(null);
  const [infoRequiredComments, setInfoRequiredComments] = React.useState(null);
  const [ivrReport, setIvrReport] = React.useState(null);
  const [ivrReportFileName, setIvrReportFileName] = React.useState(null);
  const [ivrReportFileList, setIvrReportFileList] = React.useState([]);
  const [isEditable, setIsEditable] = React.useState(false);

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setIvrReport(null);
      setIvrReportFileList([]);
      setIvrReportFileName(null);
      return;
    }
    setIvrReport(file);
    let fileName = file.name;
    const sanitizedBlobName = fileName.replace(/\s+/g, '_');
    setIvrReportFileName(sanitizedBlobName);
    setIvrReportFileList([file]);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: ['.pdf'],
    disabled: !isEditable,
    customRequest: handleFile,
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const getIvrById = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getivrbyid?ID=${params.id}`
    );
    // console.log("IVR Data: ", response?.data?.data);
    // setIvrData(response?.data?.data);
    const tempIvr = response?.data?.data;
    // get manufacturers from account
    const manufacturers = await apiServe.getDataFromBackend(`getmanufacturersfromaccount?ID=${tempIvr?.AccountID}`);
    // console.log("Manufacturers: ", manufacturers?.data?.data);
    let manOptions = [];
    manufacturers?.data?.data?.forEach((item) => {
      manOptions.push({
        label: item.ManufacturerName,
        value: item.ID
      });
    })
    setManufacturerOptions(manOptions);
    return response?.data?.data
  }

  const handleSubmit = async (type) => {
    // console.log("selectedManufacturer: ", selectedManufacturer);

    let isValid = true;

    const apiServe = new APIService();
    let postObj = {
      ivrID: params.id,
      accountID: ivrData.AccountID,
      accountName: ivrData.AccountName,
      manufacturerID: selectedManufacturer?.value,
      manufacturerName: selectedManufacturer?.label,
      caseID: caseID,
      insuranceStatus: insuranceStatus?.value,
      infoRequiredComments: infoRequiredComments,
      type: type,
    }
    console.log("Post Object: ", postObj);
    console.log("IVR Report: ", ivrReport);
    const stringifiedPostObj = JSON.stringify(postObj);
    const formData = new FormData();
    if (ivrReport) {
      formData.append("file", ivrReport);
    }
    // formData.append('file', ivrReport);
    formData.append('data', stringifiedPostObj);

    console.log("Form Data: ", formData);
    // return;
    if (!selectedManufacturer || !caseID || !insuranceStatus) {
      isValid = false;
    }
    // // if status is submitted, do not make required. else required
    // if(insuranceStatus?.value != 'Submitted') {
    //   if(!ivrReport) {
    //     message.error("Please upload IVR Report");
    //     return;
    //   }
    // }
    if (isValid === false) {
      Swal.fire(
        'Error!',
        'Please fill all the fields',
        'error'
      );
      return;
    }

    const response = await apiServe.addFileDataToBackend(formData, 'addivrmanufacturer', {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    // const response = await apiServe.addDataToBackend(formData, 'addivrmanufacturer');
    console.log("Add IVR Manufacturer Response: ", response);
    if (response?.status === 200 || response?.status === 201) {
      Swal.fire(
        'Submitted!',
        'IVR Manufacturer data has been submitted.',
        'success'
      ).then(() => {
        window.location.href = `/IVRManufacturers/${params.id}`;
        // window.location.reload();
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Error in submitting IVR Manufacturer data.',
        'error'
      )
    }
  }
  const navigate = useNavigate();
  React.useEffect(() => {
    if(userData?.Type === "Account" && !userData?.EnableIVR) {
      navigate('/');
    }
    // if(userData?.Type === "Manufacturer") {
    //   navigate('/');
    // }
    setIsEditable(true);
    getIvrById().then((data) => {
      setIvrData(data);
    });
  }, []);

  const handleButtonClick = () => {
    if (isEditable) {
      // handleSubmit(); // Trigger form submission
      setShowSubmitModal(true); // Show confirmation modal
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };

  const [showSubmitModal, setShowSubmitModal] = React.useState(false);

  const handleSaveAndNotify = async () => {
    setShowSubmitModal(false);
    await handleSubmit('notify');
  }
  const handleSave = async () => {
    setShowSubmitModal(false);
    await handleSubmit('dontNotify');
  }

  return (
    <div>
      <CustomHeader leftTopText="Welcome back!" leftBottomText="IVRAS ID" leftBottomExtraText={ivrData?.IVRASID} rightTopText="Logged in as Admin" rightBottomText="User" />
      <Button
        type="primary"
        style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
        onClick={() => handleButtonClick()}
      >
        {isEditable ? 'Save Changes' : 'Edit'}
      </Button>
      <Row gutter={16}>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Manufacturer: </label>
          <Select
            style={{ width: '100%' }}
            options={manufacturerOptions}
            onChange={(value) => { setSelectedManufacturer(value) }}
            isDisabled={!isEditable}
            // defaultValue={selectedManufacturer}
            value={selectedManufacturer}
          />
        </Col>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Case ID: </label>
          <Input
            name="CaseID"
            value={caseID}
            onChange={(e) => setCaseID(e.target.value)}
            defaultValue={caseID}
            disabled={!isEditable}
          />
        </Col>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Insurance Status</label>
          <Select
            style={{ width: '100%' }}
            options={[
              { label: 'Submitted', value: 'Submitted' },
              { label: 'Not Covered', value: 'Not Covered' },
              { label: 'Covered', value: 'Covered' },
              { label: 'Info Required', value: 'Info Required' }
            ]}
            onChange={(value) => setInsuranceStatus(value)}
            isDisabled={!isEditable}
            value={insuranceStatus}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: '20px' }}>
        <Col span={24} style={{ width: '100%' }}>
          <label className="form-label">IVR Report</label>
          <p className='input-subtitle'>Upload IVR Report is sent by the Manufacturer</p>
          <Upload.Dragger
            {...uploadProps}
            fileList={ivrReportFileList}
            onRemove={() => {
              setIvrReport(null);
              setIvrReportFileList([]);
              setIvrReportFileName(null);
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Drag or click to upload file</p>
            <p className="ant-upload-hint">
              Accepted format: PDF (Max file size limit: 4MB)
            </p>
          </Upload.Dragger>
          {/* <input type="file" onChange={handleFileChange}/> */}
        </Col>
      </Row>
      <div>
        <Modal
          title="Adding IVR Manufacturer"
          open={showSubmitModal}
          footer={false}
          onCancel={() => setShowSubmitModal(false)}
        >
          <p>
            Are you sure you want to add the IVR Manufacturer? This will notify related users about this status change via email.

            {insuranceStatus?.value === 'Info Required' &&
              <>
                <label className="form-label">Info Required Comments: </label>
                <Input
                  name="InfoRequiredComments"
                  value={infoRequiredComments}
                  onChange={(e) => setInfoRequiredComments(e.target.value)}
                  defaultValue={infoRequiredComments}
                />
              </>
            }
            <Row gutter={16} style={{ marginTop: '20px' }}>
            <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button type="primary" onClick={async () => await handleSaveAndNotify()} style={{ background: '#27a907' }}>
                Save and Notify
              </Button>
            </Col>
            <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="primary" onClick={async () => await handleSave()} style={{ background: '#ff9202' }}>
                Don't Notify
              </Button>
            </Col>
          </Row>
          </p>
        </Modal>
      </div>
    </div>
  )
}

export default AddIVRManufacturer;